import { Component, type ReactNode } from 'react';

/** Keeps one broken piece (e.g. a single chat message) from taking down the whole page. */
export class ErrorBoundary extends Component<{ children: ReactNode; fallback?: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error) { console.error('Rendering failed', error); }
  render() {
    if (this.state.error) return this.props.fallback ?? <p className="muted small">This part couldn&rsquo;t be shown. Reloading the page may fix it.</p>;
    return this.props.children;
  }
}
